<template>
	<div>
		<div class="d-flex align-center justify-end mb-2 mt-2 px-2">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loadingList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="client_reports_count"
				:loading-info="loadingList"
			/>
		</div>
    <v-data-table
			ref="table"
			:headers="headers"
			:items="client_reports"
			item-key="id"
			:loading="loadingList"
			:server-items-length="client_reports_count"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página'
			}"
    >
      <template v-slot:item.code="{ item }">
				<p class="caption mb-0">
					<b class="text-end" style="flex: 1;">{{ item.serial?.serial }} - LP{{ item.morphable?.project_line_info?.project_line?.number }} - {{ item.prefix?.prefix }} {{ item.report_index }}</b>
				</p>
      </template>
      <template v-slot:item.company="{ item }">
				<div class="text-start">
					<p class="mb-0 caption"><b>Empresa:</b> {{ item.morphable?.company.name }}</p>
					<p class="caption mb-0"><b>Proyecto:</b> {{ item.morphable?.name || item.morphable?.info?.project_detail || '--' }}</p>
					<p class="caption mb-0"><b>Dirección:</b> {{item.morphable?.info?.address?.address ?? '--'}} {{item.morphable?.info?.address?.district?.name ?? '--'}}</p>
				</div>
      </template>
			<template v-slot:item.name="{ item }">
				<div>
					<p class="caption mb-0">{{item.morphable?.name ?? '--'}}</p>
				</div>
			</template>
			<template v-slot:item.address="{ item }">
				<div>
					<p class="caption mb-0">{{item.morphable?.info?.address?.address ?? '--'}}</p>
					<p class="caption mb-0">{{item.morphable?.info?.address?.district?.name ?? '--'}}</p>
				</div>
			</template>
			<template v-slot:item.report_date="{ item }">
				<div>
					<p class="caption mb-0">{{item.created_at | toDate}}</p>
				</div>
			</template>
      <template v-slot:item.status="{ item }">
				<div>
					<p class="caption mb-0"><small>Creado: <b>{{item.created_at | toDate}}</b></small></p>
					<v-chip
						:color="item.last_status?.status | budgetStatusColor"
						label
						outlined
						x-small
						class="px-1"
					>
						<b>{{ item.last_status?.status | budgetStatus }}</b>
					</v-chip>
					<p class="ml-2 mb-0 caption">{{ item.last_status?.description }}</p>
				</div>
			</template>
      <template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="#959595"
							class="mx-1"
							@click.stop="() => { selectRow(item); openReportDetail(item.id); }"

							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-file-document-outline</v-icon>
						</v-btn>
					</template>
					<span>Ver Informe</span>
				</v-tooltip>
				<v-tooltip bottom v-if="item.budget && item.budget.payment_order.length == 0">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="#959595"
							class="mx-1"
							@click.stop="() => { selectRow(item); startPaymentUnarchive(item); }"

							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-credit-card-outline</v-icon>
						</v-btn>
					</template>
					<span>Pagar Desarchivo</span>
				</v-tooltip>
      </template>
    </v-data-table>
		<div class="d-flex align-center justify-end mt-2 px-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="client_reports_count"
				:loading-info="loadingList"
			/>
		</div>
	</div>
</template>

<script>
// import moment from 'moment'
import _debounce from 'lodash/debounce'
import {getClientReports} from '@/helpers/api/clients'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'ClientReportList',
	components: {
		DataTablePagination
	},
	props: {
		clientId: {
      type: Number,
      required: true
    },
		openReportDetail: {
      type: Function,
      required: true
    },
		unarchives: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		selected_report() {
			return this.$route.query?.r
		}
	},
	watch: {
    options: {
      handler() {
				this.getClientReports()
      },
      deep: true,
    }
	},
	data: () => ({
		selectedRowItem: null,
		loadingList: true,
		client_reports: [],
		client_reports_count: 0,
		headers: [
			{ text: 'Nº', value: 'code', align: 'start', sortable: false },
			{ text: 'Detalle', value: 'company', align: 'start', sortable: false },
			{ text: 'Estado', value: 'status', align: 'center', width: 160, sortable: false },
			{ text: 'Acciones', value: 'actions', align: 'center', width: 140, sortable: false },
		],
		searchInput: null,
		options: {
			page: 1,
			itemsPerPage: 10,
			sortBy: [],
			sortDesc: [],
		},
	}),
	mounted(){
		this.getClientReports()
		const report_id = this.$route.query.r
		if(report_id){
			this.selectedRowItem = report_id
			this.openReportDetail(report_id)
		}
		else{
			const selectedRow = JSON.parse(localStorage.getItem('selected_clients_reports_row'));
			if (selectedRow) {
				this.selectedRowItem = selectedRow
			}
		}
		eventBus.$on('reloadInformation', this.getClientReport)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this.getClientReport);
	},
	methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_reports_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.getClientReports()
		},
		getClientReport(){
			this.getClientReports()
		},
		getRowClass(item) {
			return item.id == this.selected_report ? 'custom-client-highlight-row client-row-report' : 'client-row-report';
		},
		async getClientReports(){
			this.loadingList = true
			try {
				let data = {
					...this.options,
					unarchives: this.unarchives || false,
					client_id: this.clientId,
					start: (this.options.page - 1) * this.options.itemsPerPage,
					limit: this.options.itemsPerPage,
				}
				if(this.searchInput){
					data = {...data, ...{search: this.searchInput}}
				}
				const client_report = await getClientReports(data)
				if(client_report.code == 200){
					this.client_reports = client_report.client_reports
					this.client_reports_count = client_report.client_reports_count
				}
			} catch (error) {
				console.log(error)
			}
			this.loadingList = false
		},
		startPaymentUnarchive(item){
			if(item.budget?.id){
				const url = 'https://apiarq.insomnia.cl/report-budget-confirm?rb=' + item.budget?.id;
				window.open(url, '_blank').focus();
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
	}
}
</script>

<style>
.custom-client-highlight-row {
  background-color: #e8e8e8 !important;
}
.client-row-report{
	cursor: pointer;
}
</style>